import { useState, useEffect } from 'react';

export default function ChiSiamo() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen relative">
      {/* New Background */}
      <div className="fixed inset-0 z-0 bg-gradient-to-br from-[#36090d] via-[#5a0f15] to-[#36090d]">
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-0 left-0 w-96 h-96 bg-[#e97e89] rounded-full filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#f1b2b9] rounded-full filter blur-3xl animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-[#e97e89] rounded-full filter blur-3xl animate-pulse delay-500"></div>
        </div>
      </div>

      {/* Content Overlay */}
      <div className="relative z-10">
        {/* Navigation - Sticky */}
        <nav className={`fixed top-0 left-0 right-0 z-50 shadow-md border-b border-white/20 backdrop-blur-md transition-all duration-300 ${
          isScrolled ? 'bg-[#36090d]/90 h-14' : 'bg-transparent h-16'
        }`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className={`flex justify-between items-center transition-all duration-300 ${
              isScrolled ? 'h-14' : 'h-16'
            }`}>
              <div className="flex items-center">
                <img 
                  src="https://static.readdy.ai/image/448d3dd4920f14db0013cfc0f3d75a62/51fa198fcc5d92a2ecc7c07e6e02f260.png"
                  alt="Orvia Logo"
                  className={`transition-all duration-300 ${
                    isScrolled ? 'h-8' : 'h-10'
                  }`}
                />
              </div>
              
              <div className="hidden md:block">
                <div className="ml-10 flex items-baseline space-x-8">
                  <a href="/" className="text-white/80 hover:text-[#e97e89] px-3 py-2 text-sm font-medium transition-colors">
                    Home
                  </a>
                  <a href="/chi-siamo" className="text-white hover:text-[#e97e89] px-3 py-2 text-sm font-medium transition-colors">
                    Chi Siamo
                  </a>
                  <a href="/contatti" className="text-white/80 hover:text-[#e97e89] px-3 py-2 text-sm font-medium transition-colors">
                    Contatti
                  </a>
                </div>
              </div>

              <div className="md:hidden">
                <button
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  className="text-white hover:text-[#e97e89] p-2"
                >
                  <i className="ri-menu-line text-xl"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Mobile menu */}
          {isMenuOpen && (
            <div className="md:hidden bg-[#36090d]/95 backdrop-blur-md">
              <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t border-white/20">
                <a href="/" className="text-white/80 hover:text-[#e97e89] block px-3 py-2 text-base font-medium">
                  Home
                </a>
                <a href="/chi-siamo" className="text-white block px-3 py-2 text-base font-medium">
                  Chi Siamo
                </a>
                <a href="/contatti" className="text-white/80 hover:text-[#e97e89] block px-3 py-2 text-base font-medium">
                  Contatti
                </a>
              </div>
            </div>
          )}
        </nav>

        {/* Hero Section */}
        <section className="relative py-20 lg:py-32 pt-32">
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl lg:text-6xl font-extrabold text-white mb-6 leading-tight tracking-wider uppercase"
                style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Chi Siamo
            </h1>
            
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed"
               style={{ fontFamily: 'Lato, sans-serif' }}>
              Scopri la storia, i valori e le persone che rendono Orvia la tua agenzia digitale di fiducia
            </p>
          </div>
        </section>

        {/* Values Section */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl lg:text-4xl font-extrabold text-white mb-6 tracking-wider uppercase"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}>
                I Nostri Valori
              </h2>
              <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed"
                 style={{ fontFamily: 'Lato, sans-serif' }}>
                Principi che guidano ogni nostro progetto e definiscono il nostro approccio al lavoro
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-white/20 hover:bg-[#e97e89]/20 hover:border-[#e97e89]/50">
                <div className="w-16 h-16 bg-[#e97e89]/20 rounded-full flex items-center justify-center mb-6 mx-auto">
                  <i className="ri-lightbulb-flash-line text-3xl text-[#e97e89]"></i>
                </div>
                <h3 className="text-xl font-extrabold text-white mb-4 text-center tracking-wide uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Innovazione continua
                </h3>
                <p className="text-white/90 leading-relaxed text-center"
                   style={{ fontFamily: 'Lato, sans-serif' }}>
                  In un mondo che cambia ogni giorno, crediamo nell'aggiornamento costante e nella ricerca di soluzioni tecnologiche sempre più performanti.
                </p>
              </div>

              <div className="p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-white/20 hover:bg-[#36090d]/30 hover:border-[#36090d]/50">
                <div className="w-16 h-16 bg-[#e97e89]/20 rounded-full flex items-center justify-center mb-6 mx-auto">
                  <i className="ri-brush-line text-3xl text-[#e97e89]"></i>
                </div>
                <h3 className="text-xl font-extrabold text-white mb-4 text-center tracking-wide uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Creatività e funzionalità
                </h3>
                <p className="text-white/90 leading-relaxed text-center"
                   style={{ fontFamily: 'Lato, sans-serif' }}>
                  Ogni sito web deve raccontare una storia, ma anche funzionare perfettamente su ogni dispositivo. Design e codice si fondono per creare esperienze uniche e memorabili.
                </p>
              </div>

              <div className="p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-white/20 hover:bg-[#e97e89]/20 hover:border-[#e97e89]/50">
                <div className="w-16 h-16 bg-[#e97e89]/20 rounded-full flex items-center justify-center mb-6 mx-auto">
                  <i className="ri-team-line text-3xl text-[#e97e89]"></i>
                </div>
                <h3 className="text-xl font-extrabold text-white mb-4 text-center tracking-wide uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Trasparenza e collaborazione
                </h3>
                <p className="text-white/90 leading-relaxed text-center"
                   style={{ fontFamily: 'Lato, sans-serif' }}>
                  Il cliente è parte attiva del nostro processo. Condividiamo ogni fase di sviluppo, dal concept alla messa online.
                </p>
              </div>

              <div className="p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-white/20 hover:bg-[#36090d]/30 hover:border-[#36090d]/50">
                <div className="w-16 h-16 bg-[#e97e89]/20 rounded-full flex items-center justify-center mb-6 mx-auto">
                  <i className="ri-bar-chart-box-line text-3xl text-[#e97e89]"></i>
                </div>
                <h3 className="text-xl font-extrabold text-white mb-4 text-center tracking-wide uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Risultati concreti
                </h3>
                <p className="text-white/90 leading-relaxed text-center"
                   style={{ fontFamily: 'Lato, sans-serif' }}>
                  Non vendiamo promesse, ma risultati. Analizziamo dati, misuriamo performance e ottimizziamo costantemente.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="py-20">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl lg:text-4xl font-extrabold text-white mb-8 tracking-wider uppercase"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  🧠 La Storia di Orvia
                </h2>
                
                <div className="space-y-6 text-lg text-white/90 leading-relaxed"
                     style={{ fontFamily: 'Lato, sans-serif' }}>
                  <p>
                    Orvia nasce dall'unione di professionisti del web con una passione comune: 
                    <strong className="text-[#e97e89]"> trasformare la tecnologia in opportunità</strong> per le persone e le imprese.
                  </p>
                  
                  <p>
                    Ogni progetto è per noi una storia da raccontare, un percorso da costruire insieme al cliente, passo dopo passo.
                  </p>
                  
                  <p>
                    Nel corso degli anni, abbiamo lavorato con piccole aziende, startup, brand internazionali e professionisti, 
                    sempre mantenendo un approccio umano e personalizzato.
                  </p>
                  
                  <p>
                    Per noi, ogni sito web è una connessione tra la tua visione e il mondo.
                  </p>
                  
                  <blockquote className="border-l-4 border-[#e97e89] pl-6 py-4 rounded-r-2xl border border-white/20">
                    <p className="text-xl font-semibold text-white italic"
                       style={{ fontFamily: 'Playfair Display, serif' }}>
                      "Non basta essere online, bisogna esserci nel modo giusto."
                    </p>
                    <cite className="text-sm text-white/80 mt-2 block">La nostra filosofia</cite>
                  </blockquote>
                </div>
              </div>
              
              <div className="relative">
                <img 
                  src="https://public.readdy.ai/ai/img_res/f1673b30e3cc7d61aa5dd204f45c5734.jpg"
                  alt="Il team di Orvia"
                  className="w-full h-auto rounded-2xl shadow-2xl object-cover"
                />
                
                <div className="absolute -bottom-6 -right-6 bg-[#e97e89] text-white p-6 rounded-2xl shadow-lg">
                  <div className="text-center">
                    <div className="text-3xl font-extrabold tracking-wider uppercase" style={{ fontFamily: 'Montserrat, sans-serif' }}>5+</div>
                    <div className="text-sm" style={{ fontFamily: 'Lato, sans-serif' }}>Anni di esperienza</div>
                  </div>
                </div>
                
                <div className="absolute -top-6 -left-6 bg-[#36090d] text-white p-6 rounded-2xl shadow-lg">
                  <div className="text-center">
                    <div className="text-3xl font-extrabold tracking-wider uppercase" style={{ fontFamily: 'Montserrat, sans-serif' }}>100+</div>
                    <div className="text-sm" style={{ fontFamily: 'Lato, sans-serif' }}>Progetti completati</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="py-20 bg-gradient-to-r from-[#36090d]/95 to-[#e97e89]/95 backdrop-blur-sm">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl lg:text-4xl font-extrabold text-white mb-8 tracking-wider uppercase"
                style={{ fontFamily: 'Montserrat, sans-serif' }}>
              La Nostra Missione
            </h2>
            
            <div className="space-y-6 text-lg text-white/90 leading-relaxed"
                 style={{ fontFamily: 'Lato, sans-serif' }}>
              <p>
                Crediamo che ogni azienda, indipendentemente dalle dimensioni, meriti una presenza digitale di qualità. 
                La nostra missione è democratizzare l'accesso a soluzioni web professionali.
              </p>
              
              <p>
                Non siamo solo sviluppatori o designer: siamo partner strategici che accompagnano i nostri clienti 
                nel loro percorso di crescita digitale.
              </p>
              
              <blockquote className="text-2xl font-bold text-white border-l-4 border-white/50 pl-6 py-4"
                         style={{ fontFamily: 'Playfair Display, serif' }}>
                "Trasformiamo visioni in realtà digitali che generano valore concreto."
              </blockquote>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl lg:text-4xl font-extrabold text-white mb-6 tracking-wider uppercase"
                style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Vuoi far parte della famiglia Orvia?
            </h2>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed"
               style={{ fontFamily: 'Lato, sans-serif' }}>
              Contattaci per scoprire come possiamo aiutarti a realizzare i tuoi obiettivi digitali
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="/contatti" className="bg-[#e97e89] text-white px-8 py-4 rounded-2xl font-semibold hover:bg-[#36090d] transition-all duration-300 whitespace-nowrap cursor-pointer text-center shadow-md hover:shadow-lg transform hover:-translate-y-1">
                Inizia il tuo progetto
              </a>
              <a href="/" className="border-2 border-[#e97e89] text-[#e97e89] px-8 py-4 rounded-2xl font-semibold hover:bg-[#e97e89] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer text-center shadow-md hover:shadow-lg transform hover:-translate-y-1">
                Scopri i nostri servizi
              </a>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="text-white py-16 border-t border-white/20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-4 gap-8">
              <div className="md:col-span-2">
                <img 
                  src="https://static.readdy.ai/image/448d3dd4920f14db0013cfc0f3d75a62/51fa198fcc5d92a2ecc7c07e6e02f260.png"
                  alt="Orvia Logo"
                  className="h-8 mb-4"
                />
                <p className="text-white/80 mb-6 leading-relaxed"
                   style={{ fontFamily: 'Lato, sans-serif' }}>
                  La tua agenzia digitale di fiducia per lo sviluppo web, design e marketing digitale. 
                  Trasformiamo le tue idee in successi online.
                </p>
                <div className="flex space-x-4">
                  <a href="https://www.instagram.com/orvia.it?igsh=bGJwNXVva3VxdTM4" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#e97e89] rounded-full flex items-center justify-center hover:bg-[#36090d] transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-white"></i>
                  </a>
                  <a href="https://www.tiktok.com/@orvia.com?_r=1&_t=ZN-93GUTAQtSeE" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#e97e89] rounded-full flex items-center justify-center hover:bg-[#36090d] transition-colors cursor-pointer">
                    <i className="ri-tiktok-line text-white"></i>
                  </a>
                </div>
              </div>
              
              <div>
                <h4 className="text-lg font-semibold mb-4 tracking-wide uppercase" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Servizi
                </h4>
                <ul className="space-y-2 text-white/80">
                  <li><a href="/" className="hover:text-[#e97e89] transition-colors cursor-pointer">Sviluppo Web</a></li>
                  <li><a href="/" className="hover:text-[#e97e89] transition-colors cursor-pointer">Design UX/UI</a></li>
                  <li><a href="/" className="hover:text-[#e97e89] transition-colors cursor-pointer">Social Media</a></li>
                  <li><a href="/" className="hover:text-[#e97e89] transition-colors cursor-pointer">SEO & Marketing</a></li>
                  <li><a href="/" className="hover:text-[#e97e89] transition-colors cursor-pointer">Copywriting</a></li>
                </ul>
              </div>
              
              <div>
                <h4 className="text-lg font-semibold mb-4 tracking-wide uppercase" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Contatti
                </h4>
                <ul className="space-y-2 text-white/80">
                  <li className="flex items-center">
                    <i className="ri-mail-line mr-2"></i>
                    OrviaClient@gmail.com
                  </li>
                  <li className="flex items-center">
                    <i className="ri-phone-line mr-2"></i>
                    +39-3518712315
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
              <p className="text-white/60 text-sm">
                © 2024 Orvia. Tutti i diritti riservati.
              </p>
              <div className="flex space-x-6 mt-4 md:mt-0">
                <a href="#" className="text-white/60 hover:text-[#e97e89] text-sm transition-colors cursor-pointer">
                  Privacy Policy
                </a>
                <a href="#" className="text-white/60 hover:text-[#e97e89] text-sm transition-colors cursor-pointer">
                  Cookie Policy
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
